(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-strip')) {
    customElements.define(
      'collection-strip',
      class CollectionStrip extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.collection-strip__track');
          this.prev = this.querySelector('.collection-strip__arrow--prev');
          this.next = this.querySelector('.collection-strip__arrow--next');
          if (!this.track) return;

          this.onScroll = () => this.updateArrows();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);

          if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
          if (this.next) this.next.addEventListener('click', () => this.step(1));

          this.paused = false;
          ['mouseenter', 'focusin', 'touchstart'].forEach((e) =>
            this.addEventListener(e, () => (this.paused = true), { passive: true })
          );
          ['mouseleave', 'focusout'].forEach((e) =>
            this.addEventListener(e, () => (this.paused = false))
          );

          this.updateArrows();
          this.startAutoplay();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          window.removeEventListener('resize', this.onScroll);
        }

        step(dir) {
          const amount = Math.max(120, this.track.clientWidth * 0.7) * dir;
          this.track.scrollBy({ left: amount, behavior: 'smooth' });
        }

        updateArrows() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const overflow = scrollWidth - clientWidth > 4;
          if (this.prev) this.prev.hidden = !overflow || scrollLeft <= 4;
          if (this.next) this.next.hidden = !overflow || scrollLeft + clientWidth >= scrollWidth - 4;
        }

        startAutoplay() {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.dataset.autoplay !== 'true' || reduced) return;
          const ms = (parseInt(this.dataset.speed, 10) || 4) * 1000;
          this.timer = setInterval(() => {
            if (this.paused || document.hidden) return;
            const { scrollLeft, scrollWidth, clientWidth } = this.track;
            if (scrollWidth - clientWidth <= 4) return;
            if (scrollLeft + clientWidth >= scrollWidth - 4) {
              this.track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              this.step(1);
            }
          }, ms);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
